module.exports = __webpack_public_path__ + "static/media/gsg-affiliate-partner.8290a9cf.jpg";